<template>
    <div>
        <!-- HERO IMAGE -->
        <div class="home-hero">
            <div class="home-hero-img"></div>
            <div class="home-hero-content">
                <div class="container">
                    <div class="row">
                        <div class="col-sm" style="-webkit-transform: translateZ(-2000px);">
                            <img class="bk perspective-image-left" style="width:720px;height:405px;pointer-events:none;border-radius:3px" src="../img/example_event.jpg" />
                        </div>
                        <div class="col-sm">
                            <br />
                            <br />
                            <header>
                                <h1>Software for trainers and coaches</h1>
                                <h2>Manage your events and boost learner engagement</h2>
                            </header>
                            <br />
                            <router-link :to="{ name: 'SignUp' }" class="btn hero-btn">Get Started For Free</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <main role="main">
            <!-- FEATURES -->
            <div id="contact" class="contact-cta">
                <div class="container">
                    <div class="row d-flex">

                        <div class="col-md-6 headline-feature">
                            <h2>For individuals and teams</h2>
                            <ul class="headline-details">
                                <li><i class="bts bt-check"></i>Freelance trainers and facilitators</li>
                                <li><i class="btr bt-check"></i>Coaches</li>
                                <li><i class="btr bt-check"></i>L&D teams</li>
                                <li><i class="btr bt-check"></i>Training consultancies</li>
                            </ul>
                        </div>

                        <div class="col-md-6 headline-feature">
                            <h2>For all types of learning event</h2>
                            <ul class="headline-details">
                                <li><i class="btr bt-check"></i>Large scale development programmes</li>
                                <li><i class="btr bt-check"></i>Group workshops</li>
                                <li><i class="btr bt-check"></i>Bite-sized learning sessions</li>
                                <li><i class="btr bt-check"></i>Individual coaching</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <!-- ADVANTAGES & SCREENSHOTS -->
            <div class="giraffepad-advantages">
                <div class="container">
                    <div class="advantage-row">
                        <div class="row advantage-header">
                            <h2>Before your event</h2>
                            <p>
                                Break the ice and get the conversation started. Have learners arrive primed and ready to go.
                                Use personal objectives to design more tailored content. Put an end to lugging printouts around.
                            </p>
                        </div>
                    </div>
                    <div class="row d-flex">
                        <div class="col-md-6 headline-feature">
                            <br />
                            <ul class="headline-details">
                                <li><i class="bts bt-angle-right"></i>Share the purpose and objectives of the event</li>
                                <li><i class="bts bt-angle-right"></i>Provide access to resources</li>
                                <li><i class="bts bt-angle-right"></i>Collect learners’ personal objectives</li>
                                <li><i class="bts bt-angle-right"></i>Create a learning community</li>
                                <li><i class="bts bt-angle-right"></i>Handle individual questions and concerns</li>
                            </ul>
                            <br />
                        </div>

                        <div class="col-md-6 headline-feature" style="-webkit-transform: translateZ(-2000px);">
                            <img class="bk perspective-image-right" style="display:block;margin-left:auto;margin-right:auto;width:720px;height:405px;pointer-events:none;border-radius:3px" src="../img/example_event.jpg" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="giraffepad-advantages">
                <div class="container">
                    <div class="advantage-row">
                        <div class="row advantage-header">
                            <h2>During your event</h2>
                            <p>
                                Ensure the enthusiasm, ideas and learning commitments are not left behind but securely stored and easy for you to follow up on.
                            </p>
                        </div>
                    </div>
                    <div class="row d-flex">
                        <div class="col-md-6 headline-feature" style="-webkit-transform: translateZ(-2000px);">
                            <img class="bk perspective-image-left" style="display:block;margin-left:auto;margin-right:auto;width:272px;height:289px;pointer-events:none;border-radius:3px" src="../img/example_resources.jpg" />
                        </div>

                        <div class="col-md-6 headline-feature">
                            <br />
                            <br />
                            <ul class="headline-details">
                                <li><i class="bts bt-angle-right"></i>Record flipcharts, whiteboards and any other learning output</li>
                                <li><i class="bts bt-angle-right"></i>Capture learners’ actions and commitments</li>
                            </ul>
                        </div>
                    </div>
                    <br />
                </div>
            </div>
            <div class="giraffepad-advantages">
                <div class="container">
                    <div class="advantage-row">
                        <div class="row advantage-header">
                            <h2>After your event</h2>
                            <p>
                                Foster community and support the transfer of learning back in the workplace.
                            </p>
                        </div>
                    </div>
                    <div class="row d-flex">
                        <div class="col-md-6 headline-feature">
                            <br />
                            <ul class="headline-details">
                                <li><i class="bts bt-angle-right"></i>Easily collect feedback</li>
                                <li><i class="bts bt-angle-right"></i>Coach and motivate via private chat</li>
                                <li><i class="bts bt-angle-right"></i>Follow up and keep engagement levels high with group chat</li>
                            </ul>
                            <br />
                        </div>

                        <div class="col-md-6 headline-feature" style="-webkit-transform: translateZ(-2000px);">
                            <img class="bk perspective-image-right" style="display:block;margin-left:auto;margin-right:auto;width:497px;height:349px;pointer-events:none;border-radius:3px" src="../img/example_group_chat.jpg" />
                        </div>
                    </div>
                    <br />
                </div>
            </div>
            <!-- FEATURES -->
            <div class="giraffepad-intro">
                <div class="container">
                    <div class="row d-flex">

                        <div class="col-md-4 key-feature">
                            <i class="btr bt-lock"></i>
                            <h3>Everything in one safe place</h3>
                            <p>Life gets easier (and less expensive) with your tools in one place. GiraffePad lets you streamline your workload to manage events, start conversations and share content quickly and securely on any device.</p>
                        </div>

                        <div class="col-md-4 key-feature">
                            <i class="btr bt-clock"></i>
                            <h3>Engage sooner for better results</h3>
                            <p>Early engagement with learners means less warm up time during events and more quality time face to face. Build rapport, discuss ideas and get people talking before you even step foot in the room.</p>
                        </div>

                        <div class="col-md-4 key-feature">
                            <i class="btr bt-share"></i>
                            <h3>Easy-to-share content</h3>
                            <p>No more lost notes or hours wasted printing costly handouts. Simply share your content before, during and after your event so that learners stay engaged on the day and can access resources later.</p>
                        </div>

                        <div class="col-md-4 key-feature">
                            <i class="btr bt-rocket"></i>
                            <h3>Boost engagement and accountability</h3>
                            <p>Instant one-to-one and group messaging keeps the conversation going. Constant contact means you can answer questions, send reminders and share content remotely to keep learners on track long after your event.</p>
                        </div>

                        <div class="col-md-4 key-feature">
                            <i class="btr bt-money"></i>
                            <h3>Demonstrate added value</h3>
                            <p>Delight your clients with dazzling results when you take control and engage with learners throughout the training process for the most efficient and effective experience possible.</p>
                        </div>

                        <div class="col-md-4 key-feature">
                            <i class="btr bt-laptop"></i><i class="btr bt-mobile"></i>
                            <h3>Unlimited access on any device</h3>
                            <p>After your free trial a monthly or annual subscription ensures ongoing access to all GiraffePad features for as many clients, learners and events as you like. Stay connected anytime, anywhere via your phone.</p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- TESTIMONIALS -->
            <div class="container testimonials">
                <div class="row">
                    <div class="col-sm-12">
                        <h2 class="section-header">Happy Clients</h2>

                        <b-carousel indicators no-hover-pause :interval="6000">
                            <b-carousel-slide>
                                <template v-slot:img>
                                    <blockquote>
                                        <img src="../img/testimonials/AngelaMitchell.png" alt="Angela Mitchell" height="120" width="120">
                                        <p>"GiraffePad has been fabulously useful for me - it allows me to put all my resources in one place. Perhaps even more importantly my clients have been so excited to use this with their delegates on their courses."</p>
                                        <h4>Angela Mitchell<span>Juicing the Lemon – Performance Management Specialist</span></h4>
                                    </blockquote>
                                </template>
                            </b-carousel-slide>
                            <b-carousel-slide>
                                <template v-slot:img>
                                    <blockquote>
                                        <img src="../img/testimonials/AudreyBodman.jpg" alt="Audrey Bodman" height="120" width="120">
                                        <p>"GiraffePad gives you a process to go through to engage your delegates from start to finish. I would not be without it!"</p>
                                        <h4>Audrey Bodman<span>Outshine Telephone Training &amp; Resources</span></h4>
                                    </blockquote>
                                </template>
                            </b-carousel-slide>
                            <b-carousel-slide>
                                <template v-slot:img>
                                    <blockquote>
                                        <img src="../img/testimonials/ChristineMorrison.jpg" alt="Christine Morrison" height="120" width="120">
                                        <p>"I like the professionalism and credibility GiraffePad gives me with clients and how it helps me take control of the whole learning process."</p>
                                        <h4>Christine Morrison<span>CMA Training</span></h4>
                                    </blockquote>
                                </template>
                            </b-carousel-slide>
                            <b-carousel-slide>
                                <template v-slot:img>
                                    <blockquote>
                                        <img src="../img/testimonials/EmmaWilliams.jpg" alt="Emma Williams" height="120" width="120">
                                        <p>"As a Freelance trainer you are often going in to a room with no idea of who you are meeting… GiraffePad gives me the chance to really engage with my learners and find out their objectives."</p>
                                        <h4>Emma Williams<span>EJW Solutions</span></h4>
                                    </blockquote>
                                </template>
                            </b-carousel-slide>
                        </b-carousel>
                    </div>
                </div>
            </div>
            <!-- CONTACT PANEL -->
            <div id="contact" class="contact-cta">
                <div class="container">
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="privy-embed-form" data-campaign="601821"></div>
                        </div>
                        <div class="col-sm-6">
                            <br />
                            <br />
                            <h5>Have a question or want to know more?</h5>
                            <h5>Send a message, call or drop us an email :-</h5>
                            <h5>
                                <i class="btr bt-phone"></i><a href="tel:+447940441729">07940 441 729</a><br>
                                <i class="btr bt-envelope"></i><a href="mailto:support@giraffepad.com">support@giraffepad.com</a>
                            </h5>
                        </div>
                    </div>
                </div>
            </div>
            <div class="main-site-footer">
                <div class="container">
                    <div class="row">
                        <div class="col-md-4 footer-col">
                            <h5>GiraffePad Ltd.</h5>
                            <p>
                                1 Swan Wood Park<br>
                                Gun Hill, Horam<br>
                                East Sussex TN21 0LL<br>
                                United Kingdom
                            </p>
                            <p>Company number: 10993398<br>VAT number: 279 448 443</p>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'Home',
};
</script>
